query getSaleInventoryState($from: DateTime, $to: DateTime, $email: String) {
  saleInventoryState(from: $from, to: $to, email: $email) {
    ...fullInventoryState
  }
}
